import { chunkArray } from '@ori/presentation-utils';
import { BundleImage, BundleImagesRow, BundleImages, BundleImagesInner } from "./styles";
import { PRODUCT_TILE_BUNDLES_IMAGES } from "../../common";
import { ImagePlaceholder } from "../ImagePlaceholder";
import { LazyImage } from "../LazyImage";
import { jsx as _jsx } from "react/jsx-runtime";
export var Image = function Image(_ref) {
  var productImageUrls = _ref.productImageUrls;
  if (productImageUrls && productImageUrls.length > 1) {
    var rows = chunkArray(productImageUrls, 4);
    return /*#__PURE__*/_jsx(BundleImages, {
      "data-testid": PRODUCT_TILE_BUNDLES_IMAGES,
      children: /*#__PURE__*/_jsx(BundleImagesInner, {
        children: rows.map(function (imageUrls) {
          return /*#__PURE__*/_jsx(BundleImagesRow, {
            children: imageUrls.map(function (imageUrl) {
              return /*#__PURE__*/_jsx(BundleImage, {
                alt: imageUrl,
                src: imageUrl
              }, imageUrl);
            })
          }, JSON.stringify(imageUrls));
        })
      })
    });
  }
  if ((productImageUrls === null || productImageUrls === void 0 ? void 0 : productImageUrls.length) === 1) {
    return /*#__PURE__*/_jsx(LazyImage, {
      src: productImageUrls[0],
      alt: productImageUrls[0]
    });
  }
  return /*#__PURE__*/_jsx(ImagePlaceholder, {});
};
//# sourceMappingURL=Image.js.map